export default __webpack_public_path__ + "static/media/stands_ind_Toljy.5d24eb52.jpg";